import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';

import SignRiderTemplate from './SignRiderTemplate';
import RadioSelector from './RadioSelector';

const styles = theme => ({
  root: {
    maxWidth: 700,
    backgroundColor: theme.palette.background.paper,
  },
  formControl: {
    margin: theme.spacing.unit * 3,
  },
  group: {
    margin: `${theme.spacing.unit}px 0`,
    padding: 30,
  },
});

const SignRiderSelector = props => {
  const {
    classes,
    localPhoneNumber,
    signRiderTemplates,
    signRiderBrands,
    selectedSignRiderBrand,
    defaultSignRiderSize,
    selectedSignRiderVariant,
    handleChangeSignRiderBrand,
    handleChangeSignRiderTemplate,
  } = props;
  return (
    <form className={classes.root} autoComplete="off">
      <FormLabel className={classes.label}>
        Select a template for your Sign Rider
      </FormLabel>
      <FormHelperText className={classes.helperText}>
        You can select a sign rider template here.
      </FormHelperText>
      <div className={classes.searchContainer}>
        <FormControl className={classes.formControl}>
          <InputLabel htmlFor="brand">Brand</InputLabel>
          <Select
            value={selectedSignRiderBrand}
            onChange={handleChangeSignRiderBrand}
            inputProps={{
              name: 'brand',
              id: 'brand',
            }}
          >
            {signRiderBrands.map((brand, i) => {
              return (
                <MenuItem value={brand} key={`${i}-${brand}`}>
                  {brand}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
        <RadioSelector
          selectedOption={selectedSignRiderVariant}
          title={'template options'}
          handleChange={handleChangeSignRiderTemplate}
          options={getOptions(
            signRiderTemplates,
            defaultSignRiderSize,
            localPhoneNumber
          )}
        />
      </div>
    </form>
  );
};

function getOptions(templates, activeTemplateSize, localPhoneNumber) {
  const temp = templates
    .filter(template => {
      return template.size === activeTemplateSize;
    })
    .map(t => {
      return {
        label: (
          <SignRiderTemplate template={t} phoneNumber={localPhoneNumber} />
        ),
        value: t.variant,
      };
    });
  return temp;
}

export default withStyles(styles)(SignRiderSelector);



// WEBPACK FOOTER //
// ./src/components/SignRiderSelector.js